import React, { use } from "react";
import dayjs from "dayjs";
import { List, Modal } from "antd";
import { Accordion, AccordionItem, Button, Code } from "@heroui/react";
import { FormattedMessage } from "react-intl";
import "./ModalLog.css";
import { GQL } from "@binale-tech/shared";
import { gql, useQuery } from "@apollo/client";
import { CompanyContext } from "scripts/context/CompanyContext";

interface Props {
    onHide?: () => void;
    visible?: boolean;
    isLoading?: boolean;
    data?: GQL.IRecordLogs;
}

class ModalLogClass extends React.PureComponent<Props> {
    constructor(props: Props) {
        super(props);
    }

    handleHide = () => {
        this.props.onHide();
    };

    protected readonly footer = [
        <Button key="back" onPress={this.handleHide}>
            <FormattedMessage id="app.button.done" />
        </Button>,
    ];

    protected isCreated(diff: any) {
        return diff.kind === "E" && !Object.getOwnPropertyDescriptor(diff, "lhs");
    }
    protected getDiffTitle(diff: any) {
        if (this.isCreated(diff)) {
            return "Created";
        }
        return this.getKindTitle(diff.kind) + " [ " + diff.path.join(".") + " ] ";
    }
    protected getKindTitle(kind: string) {
        switch (kind) {
            case "N":
                return "Newly added";
            case "D":
                return "Deleted";
            case "E":
                return "Edited";
            case "A":
                return "Edited";
            default:
                return "Edited";
        }
    }
    protected getDiffContent(diff: any) {
        if (this.isCreated(diff)) {
            return <pre>{JSON.stringify(diff.rhs, null, 2)}</pre>;
        }
        return <pre>{JSON.stringify({ old: diff.lhs, new: diff.rhs }, null, 2)}</pre>;
    }

    render() {
        console.log(this.props);
        return (
            <Modal
                className="ModalLog"
                width={1000}
                style={{ top: 20 }}
                destroyOnHidden
                title="Log"
                open={this.props.visible}
                onOk={this.handleHide}
                onCancel={this.handleHide}
                footer={null}
            >
                <div className="ModalLog__container">
                    <List
                        size="large"
                        itemLayout="vertical"
                        className="ModalLog__List"
                        loading={this.props.isLoading}
                        dataSource={this.props.data?.logs || []}
                        renderItem={(item: GQL.IRecordLog) => (
                            <List.Item key={item.id}>
                                <List.Item.Meta
                                    title={
                                        <Code color="default">{dayjs(item.createdAt).format("DD.MM.YYYY HH:mm")}</Code>
                                    }
                                    description={item.userEmail}
                                />
                                <Accordion variant={"bordered"}>
                                    {JSON.parse(item.diff).map((v: string, i: any) => {
                                        console.log(v);
                                        return (
                                            <AccordionItem title={this.getDiffTitle(v)} key={"" + i}>
                                                {this.getDiffContent(v)}
                                            </AccordionItem>
                                        );
                                    })}
                                </Accordion>
                            </List.Item>
                        )}
                    />
                </div>
            </Modal>
        );
    }
}

const query = gql`
    query recordLogs($companyId: ID!, $recordId: ID!) {
        recordLogs(companyId: $companyId, recordId: $recordId) {
            isValid
            logs {
                id
                createdAt
                diff
                userEmail
                hash
                previousHash
            }
        }
    }
`;

export const ModalLog: React.FC<{ recordKey?: string; onHide?: () => void }> = props => {
    const { companyGQL } = use(CompanyContext);
    const { data, loading } = useQuery(query, {
        fetchPolicy: "network-only",
        skip: !props.recordKey || !companyGQL?.id,
        variables: {
            companyId: companyGQL?.id,
            recordId: props.recordKey,
        },
    });
    return (
        <ModalLogClass
            {...props}
            visible={!!props.recordKey}
            isLoading={loading}
            data={data?.recordLogs}
            onHide={props.onHide}
        />
    );
};
